// Copyright (c) 2024, Comsearch, Inc., All rights reserved

const sortByCompanyName = companyList => (
  companyList.sort((a, b) => (
    a.companyName.toUpperCase() <= b.companyName.toUpperCase()
      ? -1
      : 1
  ))
)

export default sortByCompanyName
